
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93RNOXoh3a9k3O0jzZs6JiNjoRW5pIDR7z6JWi8JXNC6oMeta } from "/codebuild/output/src3018036558/src/ark/pages/[...slug].vue?macro=true";
import { default as guiasftOe1ucdjiLXf1ldy_45acjGjPTP7wGzMnTLWcOvvx7LUMeta } from "/codebuild/output/src3018036558/src/ark/pages/blog/guias.vue?macro=true";
import { default as index2WSe_45_450FxfenMh2fLPdeYXamb5Sx8tQDMmGog7PseIcMeta } from "/codebuild/output/src3018036558/src/ark/pages/blog/index.vue?macro=true";
import { default as temasWdZqmZxNeSX5IsLFTxbbYA__LdXka1WUp4EevkcpKXsMeta } from "/codebuild/output/src3018036558/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisa5cRmtUkRAVqes3Lkx4ZRmgMOnFUlyEKWc0ODDeNPPL4Meta } from "/codebuild/output/src3018036558/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradaSTi_pHG7RlAD5oquNSSTjFqtqIURJevpTWEu3D8oia4Meta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesLHBM0ygO1EXqHbgu32V__xZY7nQV2lODlMkmkBgFVXgMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gas_TEsZEbbJIlcieiV85NPqMxlJz5kRYvWCgBDvh1PRzcMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casasgeOxz_kUoRMgV2AHPDrhw75ecgiesBsUYKjXH8pD1MMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtojQlFoikTUbtQRXIgCMfcHVlxFGNEokV7V35iw_45mCKmUMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadora3YQ0jIprBNL3XzHke_45CvjFf66ySTsQGYNS958nDKewUMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactolaKzwUO1h0uEiwU4GoLyx_RprW1QGkOyhBHmFnv1_45N0Meta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadabedtOmIS_i_PIZdPimhRozzw8d2LycCr4EgPSTpKXLMMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simulark_FeTs6tdLPDlE2QyeTxZnsAuuRHkD5khVXe1VP43HMMeta } from "/codebuild/output/src3018036558/src/ark/pages/energia/simular.vue?macro=true";
import { default as internettlvMFTxYYTPPoTaG94ORyQUCUhPrLxHAY1IMykHUZDIMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovelKU_cZp0HNpR5WTequvOLetKNP_yLQkwCmtbrg4RPumMMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaoQvoVRBuP3wtA68sd1tWma0grqZao1GIwnX8GUigjyzwMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atualpFU_45Z8_453WBA5_45TNki53PuJ4E3Zo6AeAsLaFAYo0Sm2cMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contactofxNid4lpWNuNXkFnzD5bYkU45QYVjFQPUBGt_P_Po0cMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularEM9_45Z6NficVGqyuY7BWkzsXpKl8_45nt96Drrvuem3G5wMeta } from "/codebuild/output/src3018036558/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93QRKxCuFn1ESRAsHxSpPw_82WVL_45GxR6oaAJH0AsKCq0Meta } from "/codebuild/output/src3018036558/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93jse271z1rRV7GRP2AZ8G1V9xaZBIYVdtgsfm9kPEeIkMeta } from "/codebuild/output/src3018036558/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumooR6A3gEuGzv7HDnM2bvtG3q7Rb_455zX62VtdwRs9LHTQMeta } from "/codebuild/output/src3018036558/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidade2DE6KYdMNxFFxaNlpgP_gsSXHNkMxXdovy4_ZTVBMxUMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxakp5rud_45KPefliiQqDZToQlAZXsHk5hGxRbgbnLMN0fEMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactolytrPI3xHi8dSAGFEuWEsQD_45KqoaC0vkSdbWCJ7KKmEMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processoRUpWKgH1IOw8_myva_45xycN58MiivRRe8xy3OFA_kP_454Meta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiranlkY9WYLe4Kt0I5prQ6_452Gg_45YL_45UUydJUuW06Qi_NCwMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimo2jLWgSp9w8V8PqiHX0G9zkANm639uYb5wzZDhfUSISUMeta } from "/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simularCjLMO3jvQ6wwXImNXbkUpkZaiPl7WsEXWTJIsS931EwMeta } from "/codebuild/output/src3018036558/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93NnhkNworLTnQk__45mHCxlTfyZypZ9THFCWKpo4S19_45uwMeta } from "/codebuild/output/src3018036558/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosamC_zpLcKtyIKWZrxp3fJgpDWrc3oiBEP4ON2221Hi8Meta } from "/codebuild/output/src3018036558/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as index3A8DoC0AgEEaGk6VTw7WXh4byGoYLMaTfr6eSvdojz4Meta } from "/codebuild/output/src3018036558/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93Ez5nDTtGbY_45tPOLqYVNCesu4sQHOtLjU3Cib26_45CgbgMeta } from "/codebuild/output/src3018036558/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93mMBE2DyxLupUGmPVAYYIX49at6wxmoQZYpWDgcoDLb4Meta } from "/codebuild/output/src3018036558/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simulark_FeTs6tdLPDlE2QyeTxZnsAuuRHkD5khVXe1VP43HMMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simularEM9_45Z6NficVGqyuY7BWkzsXpKl8_45nt96Drrvuem3G5wMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simularCjLMO3jvQ6wwXImNXbkUpkZaiPl7WsEXWTJIsS931EwMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src3018036558/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93NnhkNworLTnQk__45mHCxlTfyZypZ9THFCWKpo4S19_45uwMeta || {},
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosamC_zpLcKtyIKWZrxp3fJgpDWrc3oiBEP4ON2221Hi8Meta || {},
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93Ez5nDTtGbY_45tPOLqYVNCesu4sQHOtLjU3Cib26_45CgbgMeta || {},
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93mMBE2DyxLupUGmPVAYYIX49at6wxmoQZYpWDgcoDLb4Meta || {},
    component: () => import("/codebuild/output/src3018036558/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]